// 密码
//export const passwordReg = /^(\d|[a-zA-Z]){6,20}$/;
//export const passwordReg =
//  /^(?=.*[A-Za-z0-9!@#$%^&*(),.?":{}|<>])[A-Za-z0-9!@#$%^&*(),.?":{}|<>]{6,20}$/;
export const passwordReg = /^[\S]{6,20}$/;
